import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32bd26e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "closeIcon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#close-icon--sprite" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_final_modal = _resolveComponent("vue-final-modal")!

  return (_openBlock(), _createBlock(_component_vue_final_modal, {
    modelValue: _ctx.visible || _ctx.isOpen,
    onCancel: _ctx.closeHandler,
    onClickOutside: _ctx.closeHandler,
    maxWidth: _ctx.width,
    styles: {
      overflow: 'auto',
    },
    "overlay-class": "modalOverlay",
    "content-class": ['modalContent', { 'modalContentForPurchases': _ctx.isModalPurchases, 'modalAllBranches': _ctx.isModalAllBranches, 'modalOpenSupport': _ctx.isModalOpenSupport }],
    onOpened: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('opened')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.hideClose)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "closeButton",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeHandler && _ctx.closeHandler(...args)))
          }, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "onCancel", "onClickOutside", "maxWidth", "content-class"]))
}